import fetchHandler from "../../utils/fetchHandler";
import { TESTIMONIALS } from "../types/actions";

export const getTestimonials = (queryString = "") => {
	const fetchOptions = {
		url: `/api/plug_submit/${queryString}`,
		method: "GET",
		actionType: TESTIMONIALS.GET_TESTIMONIALS
	};
	return fetchHandler(fetchOptions);
};

export const getDetailTestimonial = (values) => {
	const fetchOptions = {
		url: `/api/plug_submit/${values}/get_details`,
		method: "GET",
		actionType: TESTIMONIALS.GET_TESTIMONIALS_DETAILS
	};
	return fetchHandler(fetchOptions);
};

export const addTestimonials = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/plug_submit`,
		method: "POST",
		actionType: TESTIMONIALS.ADD_TESTIMONIAL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getCountryList = () => {
	const fetchOptions = {
		url: `/api/plugs/countries`,
		method: "GET",
		actionType: TESTIMONIALS.GET_COUNTRIES
	};
	return fetchHandler(fetchOptions);
};

export const getReplacementList = () => {
	const fetchOptions = {
		url: `/api/plugs/replacements`,
		method: "GET",
		actionType: TESTIMONIALS.GET_REPLACEMENTS
	};
	return fetchHandler(fetchOptions);
};

export const submitTestimonial = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/plugs/${values.id}`,
		method: "PUT",
		actionType: TESTIMONIALS.SUBMIT_TESTIMONIAL,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getMemberTestimonialImages = (values) => {
	const fetchOptions = {
		url: `/api/plugs_image/?${values}`,
		method: "GET",
		actionType: TESTIMONIALS.GET_TESTIMONIAL_IMAGES
	};
	return fetchHandler(fetchOptions);
};

export const createTestimonialImage = (data, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/plugs_image/`,
		method: "POST",
		actionType: TESTIMONIALS.ADD_TESTIMONIAL_IMAGES,
		body: data,
		isFileUpload: true
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const deleteTestimonialImage = (data, successHandler) => {
	const fetchOptions = {
		url: `/api/plugs_image/${data.id}`,
		method: "DELETE",
		actionType: TESTIMONIALS.DELETE_IMAGE
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const editTestimonial = (values, id, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/plugs_image/${id}`,
		method: "PATCH",
		actionType: TESTIMONIALS.EDIT_TESTIMONIAL,
		body: values,
		isFileUpload: true
	};

	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const deleteTestimonial = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/plug_submit/${id}`,
		method: "DELETE",
		actionType: TESTIMONIALS.DELETE_TESTIMONIAL
	};
	return fetchHandler(fetchOptions, successHandler);
};
